function e(r) {
  switch (r.status) {
    case "verifying":
      return { type: "VERIFY_STARTED", orderId: r.orderId };
    case "accepted":
      return r.payment !== null ? { type: "SUCCEEDED", payment: r.payment, orderId: r.orderId } : null;
    case "failed":
      return {
        type: "FAILED",
        error: r.error ?? new Error("Redirect verification failed"),
        orderId: r.orderId
      };
    default:
      return null;
  }
}
export {
  e as redirectVerificationToEvent
};
//# sourceMappingURL=redirectVerificationToEvent.js.map
